import React from 'react'
// libs
import { useQuery } from '@apollo/client/react'
// graphql
import { BUSINESS_UNITS_TREE_QUERY } from 'graphql/businessUnit/queries'
// types
import { TRefetch } from 'types/refetch'
import { NetworkStatus } from '@apollo/client'
import { IBusinessUnit, IBusinessUnitsResponse, IBusinessUnitsQueryArgs } from 'types/graphql'
// utils
import get from 'lodash/get'
import { getOr, maxBy, pipe } from 'lodash/fp'

type Props = React.PropsWithChildren<unknown>

type QueryResponse = { businessUnits: IBusinessUnitsResponse }

interface Context {
  refetch: TRefetch<QueryResponse, IBusinessUnitsQueryArgs>
  isLoading: boolean
  lastPosition: number
  businessUnits: IBusinessUnit[]
}

export const BusinessUnitsAPIContext = React.createContext<Context>({} as any)

const BusinessUnitsAPI: React.FC<Props> = ({ children }) => {
  const {
    data: treeQuery,
    loading,
    refetch,
    networkStatus
  } = useQuery<QueryResponse, IBusinessUnitsQueryArgs>(BUSINESS_UNITS_TREE_QUERY, {
    variables: {
      pagination: {
        pageSkip: 0,
        pageTake: 10000
      }
    }
  })

  const businessUnits = (get(treeQuery, 'businessUnits.data') || []).map((businessUnit: IBusinessUnit) => ({
    ...businessUnit,
    title: businessUnit.description,
    isBusinessUnit: true
  }))

  const lastPosition: number = pipe<any, any, any>(maxBy('position'), getOr(0, 'position'))(businessUnits)

  const value = {
    refetch,
    lastPosition,
    businessUnits,
    isLoading: loading && networkStatus === NetworkStatus.loading
  }

  return <BusinessUnitsAPIContext.Provider value={value}>{children}</BusinessUnitsAPIContext.Provider>
}

export default BusinessUnitsAPI
